import { DefaultPage, PromptCollectionsList, PromptRolesList, PromptPagesList,GenerateLayouts, ImageToLayouts, FigmaToLayouts } from './';

export default {
  path: 'ai-prompt-builder/:version/v',
  name: 'Ai prompt builder',
  childRoutes: [
    {
      path: ':projectId',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
      isPrivate: true,
    },
    {
      path: ':projectId/prompt-collection-list',
      name: 'Prompt collections list',
      component: PromptCollectionsList,
    },
    {
      path: ':projectId/roles-list',
      name: 'Prompt roles list',
      component: PromptRolesList,
      isPrivate: true,
    },
    {
      path: ':projectId/prompt-pages-list',
      name: 'Prompt pages list',
      component: PromptPagesList,
      isPrivate: true,
    },
    {
      path: ':projectId/generate-layouts',
      name: 'Generate layouts',
      component: GenerateLayouts,
      isPrivate: true,
    },
    {
      path: ':projectId/image-to-layouts',
      name: 'Image to layouts',
      component: ImageToLayouts,
      isPrivate: true,
    },
    {
      path: ':projectId/figma-to-layouts',
      name: 'Figma to layouts',
      component: FigmaToLayouts,
      isPrivate: true,
    },

  ],
};
